// Do not modify this file, it is generated automatically by the script update-contract-addresses.mjs!

export const addresses = {
	Oil: "0x73f96b76a42e32130e9a06027744ede55e21dce9",
	Bit: "0xeb6ba2d7e06398c1b6e51cf0d80d6388e26ef70b",
	Bot: "0x93e0c72fd0c05d2166b380bce6c17cd6d095dfae",
	BotMetadata: "0x9914ba7e0889fcfc91d6a048aaedf6f8b0eae217",
	BotTeam: "0x12122d87e86af1ff32473b691ccd23f38782ff03",
	BotRevealer: "0x1bfa3f8ec23bd5194a910961df5da6ee3ddd6738",
	BotRent: "0x8485a446b4007881b008af1d7f834bcc79b91896",
	Ship: "0xb1e00fcdd6bbb582413bb4b5f10ec2517a244bf4",
	ShipMetadata: "0x3188ecd22de15d4974f6c9e2feb5006601f50f76",
	ShipRevealer: "0x5e6511e16f8e2eecd3b5bc31aa323288df1f2c1c",
	ShipTeam: "0x82a79a3b6b18719a0b7c990da5be9a858ecd2503",
	ShipRent: "0x306fd9e306236b668a903464ad203654ac36b726",
	AllianceStaking: "0x8bc8e421bf70848c9756ea8dd03eab6abead8743",
	Marketplace: "0x4bb71314ee8e7f798b1c3c4769ee42333a3fe709",
	Reward: "0x86fa4d2f89c9cbdecea8f445992623ce338b6ffa",
	BotMinter: "0x216fbe62af7883f081fadb464b3c812ded8c5a38",
	BotUpgrader: "0x755d1c173750d1ae43a6b7767d0084eb5fe0fde0",
	ShipMinter: "0xb1d8e653c4f92cf99f815a97acd1af4d00182ee6",
	RewardEarlyClaim: "0x4a4d744ae46aa4e2781aef74fdf104b65cda5654",
	DamageFix: "0x9d7a5ee926cafca141a7bfab8e424dbe0eb7f094",
	VotingEscrow: "0xd1c15e8b3d8196f9cbb76210a717f42df00f8cbd",
	BotShipPool: "0x10823951b7dcf454c0ab1b27896d6be30bed73de",
}
